module.exports = __webpack_public_path__ + "static/media/bg-squares.5b0b811c.svg";